import { Component, Emit, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import './footer.component.scss';
import { ChuteModeType } from '@/tsort/enum/chute-mode-type.enum';
import { namespace } from 'vuex-class';
import { SettingStoreConst } from '@/common/store/setting.store';
import AppConstants from '@/common/constants/app.constants';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { ScanTarget } from '@/common/enum/scan-target.enum';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';
import SortingUtils from '@/common/utils/sorting.util';

const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);
@Component({})
export default class FooterComponent extends Vue {
  @Prop() footerOfPage!: string;
  @Prop() lastChuteNo!: string;
  @Prop() wesNo!: number;
  @Prop() rejectedTask!: string;
  @Prop() scanCancelTaskServiceSettingVisibleFlag!: boolean;

  /*Sort store*/

  @SortStore.Getter
  orderNumberModeScanTarget!: number;

  @SortStore.Getter
  rfidModeScanTarget!: number;

  @SettingStore.Action
  updateChuteMode!: (value: number) => void;

  @SettingStore.Getter
  chuteMode!: ChuteModeType | undefined;

  @SortStore.Getter
  scanSetting!: ScanSettingResponse;

  mounted() {
    if (this.chuteMode === ChuteModeType.ON && this.footerOfPage === AppConstants.FOOTER_MULTI_SORTING) {
      (this.$refs['switchBtn'] as HTMLInputElement).checked = true;
    }
  }

  // モードのオンとオフを切り替えます
  private changeMode() {
    this.updateChuteMode((this.$refs['switchBtn'] as HTMLInputElement).checked ? ChuteModeType.ON : ChuteModeType.OFF);
  }

  // キャンセルタスクでイベントを公開する
  @Emit('handleCancelTask')
  async handleModalCancelTask(typeModal: string) {
    return typeModal;
  }

  /**
   * 伝票が有効時の「前キャンセル」ボタンの表示制御
   * @returns {boolean} 表示すべき場合はtrue、それ以外の場合はfalse
   */
  private get visiblePreCancelOrderNumber(): boolean {
    // 伝票モードのトグル表示している場合
    if (
      SortingUtils.isSingleSorting &&
      !this.scanSetting.rfidMode &&
      this.scanSetting.orderNumberScanUse === 1 &&
      SortingUtils.workInstruction !== 0
    ) {
      // 判定を行い結果を返す
      return this.orderNumberModeScanTarget !== ScanTarget.ORDERNUMBER;
    }
    //トグル表示していない場合はtrueを返す
    return true;
  }

  /**
   * RFIDが有効時の「前キャンセル」ボタンの表示制御
   * @returns {boolean} 表示すべき場合はtrue、それ以外の場合はfalse
   */
  private get visiblePreCancelRfid(): boolean {
    // RFIDモードのトグル表示している場合
    if (SortingUtils.isParallelSingleSorting && this.scanSetting.rfidMode) {
      // 判定を行い結果を返す
      return this.rfidModeScanTarget !== ScanTarget.RFID;
    }
    //トグル表示していない場合はtrueを返す
    return true;
  }

  render() {
    return (
      <div class="row d-flex flex-row align-items-center border-top border-2 height-footer mx-auto px-2 justify-content-between footer-fixed">
        <div class="col-4">
          <div class="row d-flex flex-row align-items-center no-gutters">
            {/* タスクのキャンセルボタン */}
            {this.footerOfPage === AppConstants.FOOTER_SINGLE_SORTING &&
              this.scanCancelTaskServiceSettingVisibleFlag &&
              this.visiblePreCancelOrderNumber &&
              this.visiblePreCancelRfid && (
                <div class="col-auto button-prev-cancel">
                  <button
                    disabled={this.wesNo <= 0 || this.rejectedTask}
                    on-click={() => this.handleModalCancelTask(SortModalType.CANCEL)}
                  >
                    前キャンセル
                  </button>
                </div>
              )}
            {this.footerOfPage !== AppConstants.FOOTER_HAND_SORTING && (
              <div class="col font-weight-bold pl-3">
                <span>前回シュートNo</span>
                <br />
                <span>{this.lastChuteNo}</span>
              </div>
            )}
          </div>
        </div>
        {/* マルチソーターページフッターのスイッチモードスキャンボタン */}
        {this.footerOfPage === AppConstants.FOOTER_MULTI_SORTING && (
          <div class="d-flex justify-content-center align-items-center col-5 pr-4">
            <h5 class="font-weight-bold d-flex align-items-center cursor-pointer" id="tooltip-icon">
              シュート先選択モード <span class="material-icons md-dark">help_outline</span>
            </h5>

            <div id="switcher">
              <input type="checkbox" ref="switchBtn" onClick={() => this.changeMode()}></input>
              <label></label>
            </div>
            <b-tooltip target="tooltip-icon" custom-class="tooltip-custom" variant="gray1">
              スキャンごとにシュートNoを選んで投下することができます
            </b-tooltip>
          </div>
        )}
        <div class="col-4 col-lg-3">{this.$slots?.swipeButton}</div>
      </div>
    );
  }
}
